
import React, { useEffect } from 'react';
import { HashRouter, BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';

import Sitemap from './components/Sitemap';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Revenues from './components/Revenues';
import Agenda from './components/Agenda';
import Profile from './components/Profile';
import Reports from './components/Reports';
import Settings from './components/Settings';
import LandingPage from './components/LandingPage';
import MobilePortal from './components/MobilePortal';

const App: React.FC = () => {
  // --- Estratégia de Roteamento ---
  // Para garantir que a aplicação não apresente tela branca em ambientes onde 
  // rewrites de servidor não estão configurados corretamente (ou localmente),
  // optamos pelo HashRouter como padrão de segurança.
  // Isso garante que a URL base seja sempre encontrada.
  const Router = HashRouter;

  useEffect(() => {
    // Check saved theme preference or default to 'light'
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }

    // Update document title and favicon
    const headerText = localStorage.getItem('app_header_text') || 'Gestão Fácil';
    document.title = headerText;
    
    const logoUrl = localStorage.getItem('report_logo_url');
    if (logoUrl) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = logoUrl;
    }

    // Capture PWA install prompt globally
    const handler = (e: any) => {
      e.preventDefault();
      (window as any).deferredPrompt = e;
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Redireciona a raiz (/) para /login imediatamente */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/sitemap" element={<Sitemap isPreview={true} />} />
          <Route path="/lp-video" element={<LandingPage />} />

          {/* Protected Routes wrapped in Sidebar Layout */}
          <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
          <Route path="/revenues" element={<ProtectedRoute><Layout><Revenues /></Layout></ProtectedRoute>} />
          <Route path="/agenda" element={<ProtectedRoute><Layout><Agenda /></Layout></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
          
          {/* Mobile Portal Exclusive Route */}
          <Route path="/mobile-portal" element={<ProtectedRoute><MobilePortal /></ProtectedRoute>} />
          
          {/* Fallback para qualquer rota desconhecida: vai para login */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
